module.exports = __webpack_public_path__ + "img/FondoNegro2.b0a94f4c.jpg";